import React from 'react';
import PropTypes from 'prop-types';

import { LEOMailingAddressFields } from './types';

export default function StreetAddress({
  address,
  address2,
  address3,
  city,
  state,
  zipcode,
  hours,
  prefix,
}) {
  return (
    <>
      <p>
        {prefix}
        <br />
        {address}
        <br />
        {address2 && (
          <>
            {address2}
            <br />
          </>
        )}
        {address3 && (
          <>
            {address3}
            <br />
          </>
        )}
        {city}
        {', '}
        {state} {zipcode}
      </p>
      {hours && (
        <p>
          {hours.split(';').map((hour) => (
            <React.Fragment key={hour}>
              {hour}
              <br />
            </React.Fragment>
          ))}
        </p>
      )}
    </>
  );
}

StreetAddress.propTypes = {
  ...LEOMailingAddressFields,
  hours: PropTypes.string,
  prefix: PropTypes.string,
};
